import clsx from 'clsx';
import { SearchField } from '../../../../../shared/ui/search-field';
import { CreateTemplateButton } from '../../../../../features/templates/ui/create-template-button/CreateTemplateButton';
import styles from '../TemplatesList.module.css';

export function TemplatesToolbar({ searchValue, onSearchChange, onSearchClear, onCreateTemplate }) {
  return (
    <div className={clsx(styles.toolbar)} aria-label="Toolbar">
      <SearchField
        className={clsx(styles.searchField)}
        ariaLabel="Search templates"
        placeholder="Search"
        value={searchValue}
        onChange={onSearchChange}
        onClear={onSearchClear}
      />
      {onCreateTemplate ? (
        <CreateTemplateButton
          size="sm"
          onClick={onCreateTemplate}
          className={clsx(styles.createButton)}
        />
      ) : null}
    </div>
  );
}
